import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const customTexts = (strictLocalize: StrictLocalizeFunction) => ({
  actionPaymentCompleted: strictLocalize({
    defaultMessage: "Payment Completed",
    description: {
      text: "Text for payment completed, example: Payment Completed",
    },
  }),
  actionPaymentError: strictLocalize({
    defaultMessage:
      "An error occurred while processing the card. Please try again or use a different card.",
    description: {
      text: "Text for an error occurred while processing the card, example: An error occurred while processing the card. Please try again or use a different card.",
    },
  }),
  actionPostbackError: strictLocalize({
    defaultMessage:
      "An error occurred while processing your action. Please try again.",
    description: {
      text: "Text for an error occurred while processing your action, example: An error occurred while processing your action. Please try again.",
    },
  }),
  clickToRetry: strictLocalize({
    defaultMessage: "Message not delivered. Refresh browser to retry.",
    description: {
      text: "Text for message not delivered, example: Message not delivered. Refresh browser to retry.",
    },
  }),
  clickToRetryForm: strictLocalize({
    defaultMessage: "Form not submitted. Click anywhere on the form to retry.",
    description: {
      text: "Text for form not submitted, example: Form not submitted. Click anywhere on the form to retry.",
    },
  }),
  connectNotificationText: strictLocalize({
    defaultMessage:
      "Sync your conversation and continue messaging us through your favorite app.",
    description: {
      text: "Text for sync your conversation and continue messaging us through your favorite app, example: Sync your conversation and continue messaging us through your favorite app.",
    },
  }),
  connectNotificationSingleText: strictLocalize({
    defaultMessage: "Be notified when you get a reply.",
    description: {
      text: "Text for be notified when you get a reply, example: Be notified when you get a reply.",
    },
  }),
  conversationListHeaderText: strictLocalize({
    defaultMessage: "My conversations",
    description: { text: "Header for my conversations in chat widget" },
  }),
  conversationListPreviewAnonymousText: strictLocalize({
    defaultMessage: "Someone",
    description: {
      text: "Text for someone in chat widget, example: someone is connecting with you",
    },
  }),
  conversationListPreviewCarouselText: strictLocalize(
    {
      defaultMessage: "{userPersonName} sent a message",
      description: {
        text: "Text for user sent a message, example: John sent a message",
      },
    },
    {
      userPersonName: "{user}",
    }
  ),
  conversationListPreviewFileText: strictLocalize(
    {
      defaultMessage: "{userPersonName} sent a file",
      description: {
        text: "Text for user sent a file, example: John sent a file",
      },
    },
    {
      userPersonName: "{user}",
    }
  ),

  conversationListPreviewFormText: strictLocalize(
    {
      defaultMessage: "{userPersonName} sent a form",
      description: {
        text: "Text for user sent a form, example: John sent a form",
      },
    },
    {
      userPersonName: "{user}",
    }
  ),
  conversationListPreviewFormResponseText: strictLocalize(
    {
      defaultMessage: "{userPersonName} filled a form",
      description: {
        text: "Text for user filled a form, example: John filled a form",
      },
    },
    {
      userPersonName: "{user}",
    }
  ),
  conversationListPreviewImageText: strictLocalize(
    {
      defaultMessage: "{userPersonName} sent an image",
      description: {
        text: "Text for user sent an image, example: John sent an image",
      },
    },
    {
      userPersonName: "{user}",
    }
  ),
  conversationListPreviewLocationRequestText: strictLocalize(
    {
      defaultMessage: "{userPersonName} sent a location request",
      description: {
        text: "Text for user sent a location request, example: John sent a location request",
      },
    },
    {
      userPersonName: "{user}",
    }
  ),
  conversationListPreviewUserText: strictLocalize({
    defaultMessage: "You",
    description: { text: "Text for you, example: You" },
  }),
  conversationListRelativeTimeJustNow: strictLocalize({
    defaultMessage: "Just now",
    description: { text: "Text for just now, example: Just now" },
  }),
  conversationListRelativeTimeMinute: strictLocalize({
    defaultMessage: "1 minute ago",
    description: { text: "Text for 1 minute ago, example: 1 minute ago" },
  }),
  conversationListRelativeTimeMinutes: strictLocalize(
    {
      defaultMessage: "{valueTime} minutes ago",
      description: {
        text: "Plural form of minutes ago, example: 6 minutes ago",
      },
    },
    {
      valueTime: "{value}",
    }
  ),
  conversationListRelativeTimeHour: strictLocalize({
    defaultMessage: "1 hour ago",
    description: { text: "Text for 1 hour ago, example: 1 hour ago" },
  }),
  conversationListRelativeTimeHours: strictLocalize(
    {
      defaultMessage: "{valueTime} hours ago",
      description: {
        text: "Plural form of hours ago, example: 6 hours ago",
      },
    },
    {
      valueTime: "{value}",
    }
  ),
  conversationListRelativeTimeYesterday: strictLocalize({
    defaultMessage: "Yesterday",
    description: { text: "Text for yesterday, example: Yesterday" },
  }),
  couldNotConnect: strictLocalize({
    defaultMessage: "Offline. You will not receive messages.",
    description: {
      text: "Text for offline, example: Offline. You will not receive messages.",
    },
  }),
  couldNotConnectRetry: strictLocalize({
    defaultMessage: "Reconnecting...",
    description: {
      text: "Text for reconnecting in chat widget, example: Reconnecting...",
    },
  }),
  couldNotConnectRetrySuccess: strictLocalize({
    defaultMessage: "You’re back online!",
    description: {
      text: "Text for you're back online, example: You're back online!",
    },
  }),
  couldNotLoadConversations: strictLocalize({
    defaultMessage: "Couldn’t load conversations.",
    description: {
      text: "Text for couldn't load conversations, example: Couldn't load conversations.",
    },
  }),
  emailChangeAddress: strictLocalize({
    defaultMessage: "Change my email",
    description: {
      text: "Button text for change my email, example: Change my email",
    },
  }),
  emailDescription: strictLocalize({
    defaultMessage:
      "To be notified by email when you get a reply, enter your email address.",
    description: {
      text: "Text for to be notified by email when you get a reply, example: To be notified by email when you get a reply, enter your email address.",
    },
  }),
  emailFieldLabel: strictLocalize({
    defaultMessage: "Email",
    description: { text: "Label for email, example: Email" },
  }),
  emailFieldPlaceholder: strictLocalize({
    defaultMessage: "Your email address",
    description: {
      text: "Placeholder for email address, example: Your email address",
    },
  }),
  emailFormButton: strictLocalize({
    defaultMessage: "Submit",
    description: { text: "Button text for submit, example: Submit" },
  }),
  emailLinkingErrorMessage: strictLocalize({
    defaultMessage: "Please submit a valid email address.",
    description: {
      text: "Error message for invalid email address, for example: Please submit a valid email address",
    },
  }),
  fetchHistory: strictLocalize({
    defaultMessage: "Load more",
    description: { text: "Button text for load more, example: Load more" },
  }),
  fetchingHistory: strictLocalize({
    defaultMessage: "Retrieving history...",
    description: {
      text: "Text for retrieving history, example: Retrieving history...",
    },
  }),
  fileTooLargeError: strictLocalize(
    {
      defaultMessage: "Max file size limit exceeded ({sizeNumber})",
      description: {
        text: "Error message for when a file exceeds the maximum size limit, for example: Max file size limit exceeded 1000",
      },
    },
    {
      sizeNumber: "{size}",
    }
  ),
  fileTypeError: strictLocalize({
    defaultMessage: "Unsupported file type.",
    description: {
      text: "Error message for unsupported file type, for example: Unsupported file type",
    },
  }),
  formErrorEntryRequired: strictLocalize({
    defaultMessage: "This entry is required",
    description: {
      text: "Error message for when a required field is empty, for example: This entry is required",
    },
  }),
  formErrorInvalidEmail: strictLocalize({
    defaultMessage: "Email is invalid",
    description: {
      text: "Error message for when an email is invalid, for example: Email is invalid",
    },
  }),
  formErrorNoLongerThan: strictLocalize(
    {
      defaultMessage:
        "Must contain no more than ({charactersNumber}) characters",
      description: {
        text: "Error message for when a text input exceeds the maximum character limit, for example: Must contain no more than 1000 characters",
      },
    },
    {
      charactersNumber: "{characters}",
    }
  ),
  formErrorNoShorterThan: strictLocalize(
    {
      defaultMessage: "Must contain at least ({charactersNumber}) characters",
      description: {
        text: "Error message for when a text input is below the minimum character limit, for example: Must contain at least 1000 characters",
      },
    },
    {
      charactersNumber: "{characters}",
    }
  ),
  formErrorUnknown: strictLocalize({
    defaultMessage: "This doesn’t look quite right",
    description: {
      text: "Error message for when an unknown error occurs, for example: This doesn’t look quite right",
    },
  }),
  formFieldSelectPlaceholderFallback: strictLocalize({
    defaultMessage: "Choose one...",
    description: {
      text: "Placeholder for select field, example: Choose one...",
    },
  }),
  frontendEmailChannelDescription: strictLocalize({
    defaultMessage:
      "To talk to us using email just send a message to our email address and we’ll reply shortly:",
    description: {
      text: "Text for to talk to us using email just send a message to our email address and we'll reply shortly",
    },
  }),
  headerText: strictLocalize({
    defaultMessage: "How can we help?",
    description: { text: "Header for chat widget, example: How can we help?" },
  }),
  imageClickToReload: strictLocalize({
    defaultMessage: "Click to reload image.",
    description: {
      text: "Text for click to reload image, example: Click to reload image.",
    },
  }),
  imageClickToView: strictLocalize(
    {
      defaultMessage: "Click to view {sizeNumber} image.",
      description: { text: "Example: click to view 100x100 image" },
    },
    {
      sizeNumber: "{size}",
    }
  ),
  imagePreviewNotAvailable: strictLocalize({
    defaultMessage: "Preview not available.",
    description: {
      text: "Text for image preview not available, example: Preview not available",
    },
  }),
  inputPlaceholder: strictLocalize({
    defaultMessage: "Type a message...",
    description: { text: "Placeholder for input, example: Type a message..." },
  }),
  inputPlaceholderBlocked: strictLocalize({
    defaultMessage: "Complete the form above...",
    description: {
      text: "Placeholder for complete the form above, example: Complete the form above...",
    },
  }),
  introAppText: strictLocalize({
    defaultMessage: "Message us below or from your favorite app.",
    description: {
      text: "Text for message us below or from your favorite app, example: Message us below or from your favorite app.",
    },
  }),
  lineChannelDescription: strictLocalize({
    defaultMessage:
      "To talk to us using LINE, scan this QR code using the LINE app and send us a message.",
    description: {
      text: "Text for to talk to us using LINE, scan this QR code using the LINE app and send us a message",
    },
  }),
  linkError: strictLocalize({
    defaultMessage:
      "An error occurred when attempting to generate a link for this channel. Please try again.",
    description: {
      text: "Error message for an error occurred when attempting to generate a link for this channel, for example: An error occurred when attempting to generate a link for this channel. Please try again.",
    },
  }),
  linkChannelPageHeader: strictLocalize({
    defaultMessage: "Sync your conversation",
    description: {
      text: "Header for the page to sync your conversation",
    },
  }),
  locationNotSupported: strictLocalize({
    defaultMessage:
      "Your browser does not support location services or it’s been disabled. Please type your location instead.",
    description: {
      text: "Text for your browser does not support location services or it's been disabled. Please type your location instead.",
    },
  }),
  locationSecurityRestriction: strictLocalize({
    defaultMessage:
      "This website cannot access your location. Please type your location instead.",
    description: {
      text: "Text for this website cannot access your location. Please type your location instead.",
    },
  }),
  locationSendingFailed: strictLocalize({
    defaultMessage: "Could not send location",
    description: {
      text: "Text for could not send location, example: Could not send location",
    },
  }),
  locationServicesDenied: strictLocalize({
    defaultMessage:
      "This website cannot access your location. Allow access in your settings or type your location instead.",
    description: {
      text: "Text for this website cannot access your location. Allow access in your settings or type your location instead.",
    },
  }),
  messageIndicatorTitlePlural: strictLocalize(
    {
      defaultMessage: "{countNumber} New messages",
      description: {
        text: "Plural form of new messages, example: 6 New messages",
      },
    },
    {
      countNumber: "{count}",
    }
  ),
  messageIndicatorTitleSingular: strictLocalize(
    {
      defaultMessage: "{countNumber} New message",
      description: {
        text: "Singular form of new message, example: 1 New message",
      },
    },
    {
      countNumber: "{count}",
    }
  ),
  messageRelativeTimeDay: strictLocalize(
    {
      defaultMessage: "{valueTime} d ago",
      description: { text: "Plural form of days ago, example: 6 d ago" },
    },
    {
      valueTime: "{value}",
    }
  ),
  messageRelativeTimeHour: strictLocalize(
    {
      defaultMessage: "{valueTime} h ago",
      description: { text: "Plural form of hours ago, example: 6 h ago" },
    },
    {
      valueTime: "{value}",
    }
  ),
  messageRelativeTimeJustNow: strictLocalize({
    defaultMessage: "Just now",
    description: { text: "Text for just now, example: Just now" },
  }),
  messageRelativeTimeMinute: strictLocalize(
    {
      defaultMessage: "{valueTime} m ago",
      description: { text: "Plural form of minutes ago, example: 6 m ago" },
    },
    {
      valueTime: "{value}",
    }
  ),
  messageDelivered: strictLocalize({
    defaultMessage: "Delivered",
    description: {
      text: "Text for delivered for chat conversation message, example: Delivered",
    },
  }),
  messageSeen: strictLocalize({
    defaultMessage: "Seen",
    description: {
      text: "Text for seen in chat conversation message, example: Seen",
    },
  }),
  messageSending: strictLocalize({
    defaultMessage: "Sending...",
    description: {
      text: "Text for sending in chat conversation message, example: Sending...",
    },
  }),
  messengerChannelDescription: strictLocalize({
    defaultMessage:
      "Connect your Facebook Messenger account to be notified when you get a reply and continue the conversation on Facebook Messenger.",
    description: {
      text: "Text for connect your Facebook Messenger account to be notified when you get a reply and continue the conversation on Facebook Messenger",
    },
  }),
  newConversationButtonText: strictLocalize({
    defaultMessage: "New Conversation",
    description: {
      text: "Button text for new conversation, example: New Conversation",
    },
  }),
  notificationSettingsChannelsDescription: strictLocalize({
    defaultMessage:
      "Sync this conversation by connecting to your favorite messaging app to continue the conversation your way.",
    description: {
      text: "Text for sync this conversation by connecting to your favorite messaging app to continue the conversation your way",
    },
  }),
  notificationSettingsChannelsTitle: strictLocalize({
    defaultMessage: "Other Channels",
    description: {
      text: "Title for other channels, example: whatsapp or telegram",
    },
  }),
  notificationSettingsConnected: strictLocalize({
    defaultMessage: "Connected",
    description: {
      text: "Text for displaying chat conversation is connected, example: Connected",
    },
  }),
  notificationSettingsConnectedAs: strictLocalize(
    {
      defaultMessage: "Connected as {userPersonName}",
      description: {
        text: "Text for connected as, example: Connected as John",
      },
    },
    {
      userPersonName: "{username}",
    }
  ),
  prechatCaptureGreetingText: strictLocalize({
    defaultMessage:
      "Hi there. To start off, we’d like to know a little bit more about you:",
    description: {
      text: "Text for hi there, to start off, we'd like to know a little bit more about you, example: Hi there 👋. To start off, we'd like to know a little bit more about you:",
    },
  }),
  prechatCaptureNameLabel: strictLocalize({
    defaultMessage: "Your name",
    description: {
      text: "Title for input of your name",
    },
  }),
  prechatCaptureNamePlaceholder: strictLocalize({
    defaultMessage: "Type your name...",
    description: {
      text: "Placeholder for type your name, example: Type your name...",
    },
  }),
  prechatCaptureEmailLabel: strictLocalize({
    defaultMessage: "Email",
    description: { text: "Title for input of email" },
  }),
  prechatCaptureEmailPlaceholder: strictLocalize({
    defaultMessage: "name@company.com",
    description: {
      text: "Placeholder for email address",
    },
  }),
  prechatCaptureConfirmationText: strictLocalize({
    defaultMessage: "Thanks for that! What can we help you with?",
    description: {
      text: "Text for thanks for that, what can we help you with, example: Thanks for that! What can we help you with?",
    },
  }),
  prechatCaptureMailgunLinkingConfirmation: strictLocalize(
    {
      defaultMessage:
        "You’ll be notified here and by email at {emailEmailAddress} once we reply.",
      description: {
        text: "Text for you'll be notified here and by email at, example: You'll be notified here and by email at johndoe@example.com once we reply",
      },
    },
    {
      emailEmailAddress: "{email}",
    }
  ),
  sendButtonText: strictLocalize({
    defaultMessage: "Send",
    description: { text: "Button text for send, example: Send" },
  }),
  settingsHeaderText: strictLocalize({
    defaultMessage: "Settings",
    description: { text: "Header for settings" },
  }),
  shareLocation: strictLocalize({ defaultMessage: "Location" }),
  smsBadRequestError: strictLocalize({
    defaultMessage:
      "We were unable to communicate with this number. Try again or use a different one.",
    description: {
      text: "Error message for we were unable to communicate with this number, for example: We were unable to communicate with this number. Try again or use a different one",
    },
  }),
  smsCancel: strictLocalize({
    defaultMessage: "Cancel",
    description: { text: "Button text for cancel, example: Cancel" },
  }),
  smsChangeNumber: strictLocalize({
    defaultMessage: "Change my number",
    description: {
      text: "Button text for change my number, example: Change my number",
    },
  }),
  smsChannelDescription: strictLocalize({
    defaultMessage:
      "Connect your SMS number to be notified when you get a reply and continue the conversation over SMS.",
    description: {
      text: "Text for connect your SMS number to be notified when you get a reply and continue the conversation over SMS",
    },
  }),
  smsChannelPendingDescription: strictLocalize(
    {
      defaultMessage:
        "Check your messages at {phoneNumber} to confirm your phone number.",
      description: {
        text: "Text for check your messages at, example: Check your messages at 1234567890 to confirm your phone number",
      },
    },
    {
      phoneNumber: "{number}",
    }
  ),
  smsContinue: strictLocalize({
    defaultMessage: "Send",
    description: {
      text: "Button text for send, example: Send",
    },
  }),
  smsInvalidNumberError: strictLocalize({
    defaultMessage: "Please submit a valid phone number.",
    description: {
      text: "Error message for invalid phone number, for example: Please submit a valid phone number",
    },
  }),
  smsLinkCancelled: strictLocalize(
    {
      defaultMessage: "Link to {appUserNumber} was cancelled.",
      description: {
        text: "Text for link to, example: Link to 1234567890 was cancelled",
      },
    },
    {
      appUserNumber: "{appUserNumber}",
    }
  ),
  smsLinkPending: strictLocalize({
    defaultMessage: "Pending",
    description: { text: "Text for pending, example: Pending" },
  }),
  smsPingChannelError: strictLocalize({
    defaultMessage: "There was an error sending a message to your number.",
    description: {
      text: "Error message for there was an error sending a message to your number, for example: There was an error sending a message to your number",
    },
  }),
  smsSendText: strictLocalize({
    defaultMessage: "Send me a text",
    description: {
      text: "Button text for send me a text, example: Send me a text",
    },
  }),
  smsStartTexting: strictLocalize({
    defaultMessage: "Start Texting",
    description: {
      text: "Button text for start texting, example: Start Texting",
    },
  }),
  smsTooManyRequestsError: strictLocalize(
    {
      defaultMessage:
        "A connection for that number was requested recently. Please try again in {minutesTime} minutes.",
      description: {
        text: "Error message for when a connection for that number was requested recently, for example: A connection for that number was requested recently. Please try again in 2 minutes",
      },
    },
    {
      minutesTime: "{minutes}",
    }
  ),
  smsTooManyRequestsOneMinuteError: strictLocalize({
    defaultMessage:
      "A connection for that number was requested recently. Please try again in 1 minute.",
    description: {
      text: "Error message for when a connection for that number was requested recently, for example: A connection for that number was requested recently. Please try again in 1 minute",
    },
  }),
  smsUnhandledError: strictLocalize({
    defaultMessage: "Something went wrong. Please try again.",
    description: {
      text: "Error message for something went wrong, for example: Something went wrong. Please try again.",
    },
  }),
  syncConversation: strictLocalize({
    defaultMessage: "Sync conversation",
    description: {
      text: "Button text for sync conversation, example: Sync conversation",
    },
  }),
  tapToRetry: strictLocalize({
    defaultMessage: "Message not delivered. Tap to retry.",
    description: {
      text: "Text for message not delivered, example: Message not delivered. Tap to retry.",
    },
  }),
  tapToRetryForm: strictLocalize({
    defaultMessage: "Form not submitted. Tap anywhere on the form to retry.",
    description: {
      text: "Text for form not submitted, example: Form not submitted. Tap anywhere on the form to retry.",
    },
  }),
  telegramChannelDescription: strictLocalize({
    defaultMessage:
      "Connect your Telegram account to be notified when you get a reply and continue the conversation on Telegram",
    description: {
      text: "Text for connect your Telegram account to be notified when you get a reply and continue the conversation on Telegram",
    },
  }),
  unsupportedMessageType: strictLocalize({
    defaultMessage: "Unsupported message type.",
    description: {
      text: "Error message for unsupported message type, for example: Unsupported message type",
    },
  }),
  unsupportedActionType: strictLocalize({
    defaultMessage: "Unsupported action type.",
    description: {
      text: "Error message for unsupported action type, for example: Unsupported action type",
    },
  }),
  uploadDocument: strictLocalize({
    defaultMessage: "File",
    description: {
      text: "Title for uploading file ",
    },
  }),
  uploadInvalidError: strictLocalize({
    defaultMessage: "Invalid file",
    description: {
      text: "Error message for invalid file, for example: Invalid file",
    },
  }),
  uploadPhoto: strictLocalize({
    defaultMessage: "Image",
    description: { text: "Title for uploading image" },
  }),
  uploadVirusError: strictLocalize({
    defaultMessage:
      "A virus was detected in your file and it has been rejected",
    description: {
      text: "Error message for a virus was detected in your file and it has been rejected, for example: A virus was detected in your file and it has been rejected",
    },
  }),
  viberChannelDescription: strictLocalize({
    defaultMessage:
      "Connect your Viber account to be notified when you get a reply and continue the conversation on Viber. To get started, scan the QR code using the Viber app.",
    description: {
      text: "Text for connect your Viber account to be notified when you get a reply and continue the conversation on Viber, for example: Connect your Viber account to be notified when you get a reply and continue the conversation on Viber. To get started, scan the QR code using the Viber app.",
    },
  }),
  viberChannelDescriptionMobile: strictLocalize({
    defaultMessage:
      "Connect your Viber account to be notified when you get a reply and continue the conversation on Viber. To get started, install the Viber app and tap Connect.",
    description: {
      text: "Text for connect your Viber account to be notified when you get a reply and continue the conversation on Viber, for example: Connect your Viber account to be notified when you get a reply and continue the conversation on Viber. To get started, install the Viber app and tap Connect.",
    },
  }),
  viberQRCodeError: strictLocalize({
    defaultMessage:
      "An error occurred while fetching your Viber QR code. Please try again.",
    description: {
      text: "Error message for an error occurred while fetching your Viber QR code, for example: An error occurred while fetching your Viber QR code. Please try again.",
    },
  }),
  wechatChannelDescription: strictLocalize({
    defaultMessage:
      "Connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat. To get started, scan this QR code using the WeChat app.",
    description: {
      text: "Text for connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat, for example: Connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat. To get started, scan this QR code using the WeChat app.",
    },
  }),
  wechatChannelDescriptionMobile: strictLocalize({
    defaultMessage:
      "Connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat. To get started, save this QR code image and upload it in the QR code scanner.",
    description: {
      text: "Text for connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat, for example: Connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat. To get started, save this QR code image and upload it in the QR code scanner.",
    },
  }),
  wechatQRCodeError: strictLocalize({
    defaultMessage:
      "An error occurred while fetching your WeChat QR code. Please try again.",
    description: {
      text: "Error message for an error occurred while fetching your WeChat QR code, for example: An error occurred while fetching your WeChat QR code. Please try again.",
    },
  }),
  whatsappChannelDescriptionDesktop: strictLocalize(
    {
      defaultMessage:
        "Sync your account to WhatsApp by scanning the QR code or clicking the link below.Then, send the pre-populated message to validate the sync request. (Your code: {codeNumber})",
      description: {
        text: "Text for sync your account to WhatsApp by scanning the QR code or clicking the link below, then send the pre-populated message to validate the sync request, for example: Sync your account to WhatsApp by scanning the QR code or clicking the link below. Then, send the pre-populated message to validate the sync request. (Your code: 123456)",
      },
    },
    {
      codeNumber: "{code}",
    }
  ),

  whatsappChannelDescriptionMobile: strictLocalize(
    {
      defaultMessage:
        "Sync your account to WhatsApp by clicking the link below.Then, send the pre-populated message to validate the sync request. (Your code: {codeNumber})",
      description: {
        text: "Text for sync your account to WhatsApp by clicking the link below, then send the pre-populated message to validate the sync request, for example: Sync your account to WhatsApp by clicking the link below. Then, send the pre-populated message to validate the sync request. (Your code: 123456)",
      },
    },
    {
      codeNumber: "{code}",
    }
  ),
  whatsappLinkingError: strictLocalize({
    defaultMessage:
      "An error occurred while fetching your WhatsApp linking information. Please try again.",
    description: {
      text: "Error message for an error occurred while fetching your WhatsApp linking information, for example: An error occurred while fetching your WhatsApp linking information. Please try again.",
    },
  }),
});
